import {useEffect, useRef, useState} from "react";

import {IApplicationData} from "../../../../application/types/IApplicationData";
import {ApplicationSource} from "../../../../application/utils/form/application_form_source";
import {useUnlockChoiceData} from "../../../hooks/use_unlock_choice_data";
import {useUnlockChoiceExperiment} from "../../../hooks/use_unlock_choice_experiment";
import {IUnlockChoiceData} from "../../../types/IUnlockChoiceData";
import {UnlockChoiceEntryPoint, UnlockChoiceOrigin} from "../../../types/UnlockChoiceEntryPoint";
import {isUnlockChoiceEligible} from "../../../utils/is_unlock_choice_eligible";
import {UnlockChoiceModal} from "./UnlockChoiceModal";

export const UNLOCK_CHOICE_DECISION_TIMEOUT_MS = 3000;
export const UNLOCK_CHOICE_LOADER_DELAY_MS = 300;

interface IProps {
    entryPoint?: UnlockChoiceEntryPoint;
    origin?: UnlockChoiceOrigin;
    propertyId?: number;
    offerId?: number;
    onLegacyStep: () => void;
    onUnavailable: () => void;
    onLeadSent: (isHomeMatchOn: boolean, sentApplication: IApplicationData | null, leadSource: ApplicationSource) => void;
    onContentOnly: () => void;
    onClose: () => void;
}

export const UnlockChoiceStep = (props: IProps) => {
    const {entryPoint, origin, propertyId, offerId, onLegacyStep, onUnavailable, onLeadSent, onContentOnly, onClose} = props;
    const isDecidedAtClick = origin === "cta";
    const isIdEligible = entryPoint !== undefined && isUnlockChoiceEligible(entryPoint, {propertyId, offerId});
    const {isLoading: isDataLoading, data} = useUnlockChoiceData({entryPoint, isEnabled: isIdEligible});
    const isEligible = isIdEligible && data !== null;
    const isIneligible = !isIdEligible || (!isDataLoading && data === null);
    const {isResolved, isTreatment, trackExposure} = useUnlockChoiceExperiment({isEnabled: isEligible && !isDecidedAtClick});
    const [hasTimedOut, setHasTimedOut] = useState(false);
    const [treatmentData, setTreatmentData] = useState<IUnlockChoiceData | null>(null);
    const hasDecidedRef = useRef(false);
    const isPending = !isIneligible && !(isEligible && (isDecidedAtClick || isResolved));
    const isLoadingClickedData = isDecidedAtClick && isDataLoading;
    const [isLoaderDelayOver, setIsLoaderDelayOver] = useState(false);

    useEffect(() => {
        if (!isPending) {
            return;
        }

        const timeoutId = setTimeout(() => setHasTimedOut(true), UNLOCK_CHOICE_DECISION_TIMEOUT_MS);

        return () => clearTimeout(timeoutId);
    }, [isPending]);

    useEffect(() => {
        if (!isLoadingClickedData) {
            return;
        }

        const timeoutId = setTimeout(() => setIsLoaderDelayOver(true), UNLOCK_CHOICE_LOADER_DELAY_MS);

        return () => clearTimeout(timeoutId);
    }, [isLoadingClickedData]);

    useEffect(() => {
        if (hasDecidedRef.current) {
            return;
        }

        if (isDecidedAtClick) {
            if (isEligible) {
                hasDecidedRef.current = true;
                setTreatmentData(data);
                return;
            }

            if (isIneligible || hasTimedOut) {
                hasDecidedRef.current = true;
                onUnavailable();
            }

            return;
        }

        if (isEligible && isResolved) {
            hasDecidedRef.current = true;
            trackExposure();

            if (isTreatment) {
                setTreatmentData(data);
                return;
            }

            onLegacyStep();
            return;
        }

        if (isIneligible || hasTimedOut) {
            hasDecidedRef.current = true;
            onLegacyStep();
        }
    }, [isDecidedAtClick, isEligible, isIneligible, isResolved, isTreatment, hasTimedOut]);

    if (entryPoint === undefined || (treatmentData === null && !isLoaderDelayOver)) {
        return null;
    }

    return <UnlockChoiceModal entryPoint={entryPoint} data={treatmentData} onLeadSent={onLeadSent} onContentOnly={onContentOnly} onClose={onClose} />;
};
import {useEffect, useRef, useState} from "react";

import {IApplicationData} from "../../../../application/types/IApplicationData";
import {ApplicationSource} from "../../../../application/utils/form/application_form_source";
import {useUnlockChoiceData} from "../../../hooks/use_unlock_choice_data";
import {useUnlockChoiceExperiment} from "../../../hooks/use_unlock_choice_experiment";
import {IUnlockChoiceData} from "../../../types/IUnlockChoiceData";
import {UnlockChoiceEntryPoint, UnlockChoiceOrigin} from "../../../types/UnlockChoiceEntryPoint";
import {isUnlockChoiceEligible} from "../../../utils/is_unlock_choice_eligible";
import {UnlockChoiceModal} from "./UnlockChoiceModal";

export const UNLOCK_CHOICE_DECISION_TIMEOUT_MS = 3000;
export const UNLOCK_CHOICE_LOADER_DELAY_MS = 300;

interface IProps {
    entryPoint?: UnlockChoiceEntryPoint;
    origin?: UnlockChoiceOrigin;
    propertyId?: number;
    offerId?: number;
    onLegacyStep: () => void;
    onUnavailable: () => void;
    onLeadSent: (isHomeMatchOn: boolean, sentApplication: IApplicationData | null, leadSource: ApplicationSource) => void;
    onContentOnly: () => void;
    onClose: () => void;
}

export const UnlockChoiceStep = (props: IProps) => {
    const {entryPoint, origin, propertyId, offerId, onLegacyStep, onUnavailable, onLeadSent, onContentOnly, onClose} = props;
    const isDecidedAtClick = origin === "cta";
    const isIdEligible = entryPoint !== undefined && isUnlockChoiceEligible(entryPoint, {propertyId, offerId});
    const {isLoading: isDataLoading, data} = useUnlockChoiceData({entryPoint, isEnabled: isIdEligible});
    const isEligible = isIdEligible && data !== null;
    const isIneligible = !isIdEligible || (!isDataLoading && data === null);
    const {isResolved, isTreatment, trackExposure} = useUnlockChoiceExperiment({isEnabled: isEligible && !isDecidedAtClick});
    const [hasTimedOut, setHasTimedOut] = useState(false);
    const [treatmentData, setTreatmentData] = useState<IUnlockChoiceData | null>(null);
    const hasDecidedRef = useRef(false);
    const isPending = !isIneligible && !(isEligible && (isDecidedAtClick || isResolved));
    const isLoadingClickedData = isDecidedAtClick && isDataLoading;
    const [isLoaderDelayOver, setIsLoaderDelayOver] = useState(false);

    useEffect(() => {
        if (!isPending) {
            return;
        }

        const timeoutId = setTimeout(() => setHasTimedOut(true), UNLOCK_CHOICE_DECISION_TIMEOUT_MS);

        return () => clearTimeout(timeoutId);
    }, [isPending]);

    useEffect(() => {
        if (!isLoadingClickedData) {
            return;
        }

        const timeoutId = setTimeout(() => setIsLoaderDelayOver(true), UNLOCK_CHOICE_LOADER_DELAY_MS);

        return () => clearTimeout(timeoutId);
    }, [isLoadingClickedData]);

    useEffect(() => {
        if (hasDecidedRef.current) {
            return;
        }

        if (isDecidedAtClick) {
            if (isEligible) {
                hasDecidedRef.current = true;
                setTreatmentData(data);
                return;
            }

            if (isIneligible || hasTimedOut) {
                hasDecidedRef.current = true;
                onUnavailable();
            }

            return;
        }

        if (isEligible && isResolved) {
            hasDecidedRef.current = true;
            trackExposure();

            if (isTreatment) {
                setTreatmentData(data);
                return;
            }

            onLegacyStep();
            return;
        }

        if (isIneligible || hasTimedOut) {
            hasDecidedRef.current = true;
            onLegacyStep();
        }
    }, [isDecidedAtClick, isEligible, isIneligible, isResolved, isTreatment, hasTimedOut]);

    if (entryPoint === undefined || (treatmentData === null && !isLoaderDelayOver)) {
        return null;
    }

    return <UnlockChoiceModal entryPoint={entryPoint} data={treatmentData} onLeadSent={onLeadSent} onContentOnly={onContentOnly} onClose={onClose} />;
};
